import { render, staticRenderFns } from "./ViewWrapper.vue?vue&type=template&id=7e8df6a1&scoped=true&"
import script from "./ViewWrapper.vue?vue&type=script&lang=ts&"
export * from "./ViewWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ViewWrapper.vue?vue&type=style&index=0&id=7e8df6a1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8df6a1",
  null
  
)

export default component.exports